import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import React, { useEffect, useState } from 'react';
import { PaymentMethodAvailability } from '../../../../types/Payment/PaymentMethodAvailability';
import PaymentSettingsService from '../../../../services/PaymentSettingsService';
import { useFormikContext } from 'formik';
import { Checkbox, makeStyles, Typography } from '@material-ui/core';
import { InputField } from '@payactive/app-common';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  payment_methods: {
    textAlign: 'left',
    display: 'block',
    color: '#0198B5',
    marginBottom: theme.spacing(2),
    fontSize: '18px',
  },
}));

export default function PaymentMethodSettings() {
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const { t } = useTranslation(['company', 'global']);
  const { values, setFieldValue } = useFormikContext<any>();
  const classes = useStyles();

  const [availablePaymentMethods, setAvailablePaymentMethods] = useState<PaymentMethodAvailability[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    Promise.all([
      PaymentSettingsService.getPaymentSettings().then((paymentSettings) => {
        setFieldValue('paymentMethods', paymentSettings.enabledPaymentMethods);
        return paymentSettings.enabledPaymentMethods;
      }),
      PaymentSettingsService.getAvailablePaymentMethods(),
    ]).then(([enabledPaymentMethods, availablePaymentMethods]) => {
      const order = new Map(enabledPaymentMethods.map((method, index) => [method, index]));
      const sortedPaymentMethods = [...availablePaymentMethods].sort(
        (a, b) => (order.get(a.paymentMethod) ?? Number.MAX_SAFE_INTEGER) - (order.get(b.paymentMethod) ?? Number.MAX_SAFE_INTEGER),
      );

      setAvailablePaymentMethods(sortedPaymentMethods);
      setLoading(false);
    });
  }, [setFieldValue]); // just here for the linter

  return (
    <div>
      <Typography variant="h5" className={classes.payment_methods}>
        {t('payment methods')}
      </Typography>

      <p>{t('payment methods description')}</p>

      {loading ? (
        <>{t('global:loading')}</>
      ) : (
        <Autocomplete
          multiple
          options={availablePaymentMethods}
          getOptionDisabled={(option) => !option.available}
          defaultValue={availablePaymentMethods.filter(
            (availablePaymentMethod) => values.paymentMethods.indexOf(availablePaymentMethod.paymentMethod) > -1,
          )}
          disableCloseOnSelect
          onChange={(_event, values) =>
            setFieldValue(
              'paymentMethods',
              values.map((paymentMethodAvailability) => paymentMethodAvailability.paymentMethod),
            )
          }
          getOptionLabel={(docType) => t(docType.paymentMethod)}
          renderOption={(d, { selected }) => (
            <>
              <Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} style={{ marginRight: 8 }} />
              {`${t(d.paymentMethod)}`} {!d.available && d.unavailabilityReason && <>({t(d.unavailabilityReason)})</>}
            </>
          )}
          renderInput={(params) => <InputField name="" {...params} label={t('payment methods')} />}
        />
      )}
    </div>
  );
}